export default "__VITE_ASSET__B7ivO9tX__"